module.exports = __webpack_public_path__ + "static/img/pro-icon-1.99e8147.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/pro-icon-1.jpg
// module id = i1Y0
// module chunks = 13